import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

export class WeaponComponent extends Component {
    static TypeName = 'weapon-component';

    @property.bool(false)
    twoHanded = false;

    @property.string('weapon')
    specialName = 'weapon';

    @property.float(10)
    baseDamage = 10;

    @property.float(10)
    price = 10;
}
